import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";

const NotFound = ({ location }) => {
  const { pathname } = location;
  var strings = require("../../translations/italian.json");

  return (
    <Fragment>
      <MetaTags>
        <title>{strings.not_found} | {strings.titleSite}</title>
          <meta
            name="description"
            content= {strings.not_found + " " + strings.siteContent}
          />
      </MetaTags>

      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        404 page
      </BreadcrumbsItem>
      <LayoutOne>
        {/* breadcrumb */}
        {/*<Breadcrumb /> */}
        <div className="error-area pt-40 pb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-7 col-lg-8 text-center">
                <div className="error">
                  <h1>404</h1>
                  <h2>OPPS! PAGINA NON TROVATA</h2>
                  <p>
                    Siamo spiacenti ma la pagina che stai cercando non esiste, oppure 
                    è stata rimossa, il nome è cambiato o non è al momento disponibile.
                  </p>
                  {/*
                  <form className="searchform mb-50">
                    <input
                      type="text"
                      name="search"
                      id="error_search"
                      placeholder="Search..."
                      className="searchform__input"
                    />
                    <button type="submit" className="searchform__submit">
                      <i className="fa fa-search" />
                    </button>
                  </form>
                  */}                 
                  <Link to={process.env.PUBLIC_URL + "/"} className="error-btn">
                    Ritorna alla Home Page
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

NotFound.propTypes = {
  location: PropTypes.object
};

export default NotFound;
